import { logs } from "./logs.js";

/**
 * Creates a logger for singleton classes.
 * Attaches log methods directly to the component instance AND returns a logger object.
 *
 * @param {Object} component - The singleton component instance or class
 * @returns {Object} Logger methods for the singleton (for backward compatibility)
 */
const createSingletonLogger = (component) => {
  // Get component name from static property or class name
  const componentName = component.constructor?.componentName ||
                        component.constructor?.name ||
                        component.componentName ||
                        'unknown';

  // Real log function - gets swapped in/out based on filters
  const logFn = function(message, ...data) {
    logs.log(componentName, null, message, ...data);
  };

  // debug always works
  component.debug = logs.debug.bind(logs, componentName, null);

  // warn, error, critical always work - bound directly
  component.warn = logs.warn.bind(logs, componentName, null);
  component.error = logs.error.bind(logs, componentName, null);
  component.critical = logs.critical.bind(logs, componentName, null);

  // Register component - this sets initial log state based on current filters
  logs.register(componentName, component, logFn);

  // Return logger object for backward compatibility
  // Note: log on this object won't be swapped, use component.log instead
  return {
    log: logFn,
    warn: component.warn,
    error: component.error,
    critical: component.critical,
    debug: component.debug
  };
};

export { createSingletonLogger };